<template>
  <div class="">
    <div v-if="label != null" class="flex items-center">
      <RequiredAsterisk v-if="required"></RequiredAsterisk>
      <div class="label-standard">{{ label }}</div>
      <img src="https://cdn2.iconfinder.com/data/icons/officeicons/PNG/48/Help.png" 
        class="w-4 inline ml-4"
        v-if="tooltip != null" 
        v-tooltip.top="{ html: propertyKey + 'Tooltip' + index }" />
      
      <div :id="propertyKey + 'Tooltip' + index" class="p-1">{{ tooltip }}</div>
    </div>

    <div class="relative form-line">
      <input type="text"
        class="input-standard"
        ref="value"
        v-model="localValue"
        v-on:keyup="format($event.target.value)"
        v-on:blur="updateValue({
          objectType: objectType,
          objectId  : objectId,
          index     : index,
          key       : propertyKey,
          value     : $event.target.value
        })" />
    </div>

    <div v-if="error" class="mt-2 text-red-600">ABN must be a 11-digit number</div>
  </div>
</template>

<script>
  import RequiredAsterisk from '@/shared/components/form/RequiredAsterisk'

  export default {

    props : {

      objectType : {
        type    : String,
        required: false
      },

      objectId : {
        type : Number,
        required : false
      },

      label : {
        type    : String,
        required: false
      },

      tooltip : {
        type    : String,
        required: false
      },

      propertyKey : {
        type    : String,
        required: false
      },
      // Object name is required if data array consist of two different data model e.g "broker" & "user" and we use object name to specfiy for which model we are updating the data in this component.
      objectName : {
        type    : String,
        required: false
      },

      value : {
        // type    : String,
        required: false
      },

      updateValue : {
        type : Function,
        required : false
      },

      index : {
        type    : Number,
        required: false,
      },

      required : {
        type    : Boolean,
        required: false,
        default : false
      }
    },

    components: {
      RequiredAsterisk
    },

    watch: {
      value : {
        
        deep     : true,
        immediate: true,

        handler(newValue, oldValue) {
          this.localValue = newValue
        },

      },
    },

    data() {
      return {
        localValue: this.value,
        error     : false
      }
    },

    mounted() {
      this.format(this.localValue)
    },

    methods : {
      format(val) {
        if(val != null && val.length > 0) {
          val = val.replace(/[^0-9]/g, '')
          this.localValue = (val.substring(0,2) + ' ' + val.substring(2,5) + ' ' + val.substring(5,8) + ' ' + val.substring(8)).trim()
          this.error = !(this.localValue.length == 0 || this.localValue.length == 14)
        }
      }
    }
  }
</script>